/* ============================================================
   CORDSET PAIRED PRODUCT — JAVASCRIPT
   File: assets/cordset-product.js
   ============================================================ */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {

    /* ── Read JSON data from script tags ─────────────────── */
    function readJSON(id) {
      var el = document.getElementById(id);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    var topVariants    = readJSON('cordset-top-variants')    || [];
    var bottomVariants = readJSON('cordset-bottom-variants') || [];
    var topOptions     = readJSON('cordset-top-options')     || [];
    var bottomOptions  = readJSON('cordset-bottom-options')  || [];

    /*
      Build a map: { groupKey -> optionIndex }
      e.g. for top product with options ["Color","Size"]:
        "top-color" -> 0   (option1)
        "top-size"  -> 1   (option2)

      For bottom product with options ["Color","Product Chest Size (in Inches)"]:
        "bottom-color" -> 0  (option1)
        "bottom-product chest size (in inches)" -> 1  (option2)
    */
    function buildGroupMap(optionNames, prefix) {
      var map = {};
      optionNames.forEach(function (name, index) {
        var key = prefix + '-' + name.toLowerCase();
        map[key] = index; /* 0-based index → option1/option2/option3 */
      });
      return map;
    }

    var topGroupMap    = buildGroupMap(topOptions,    'top');
    var bottomGroupMap = buildGroupMap(bottomOptions, 'bottom');

    /* ── Selections store ───────────────────────────────── */
    /*
      Store: { "top-color": "Blue", "top-size": "S", "bottom-color": "Black", ... }
      Keys are built from prefix + option name lowercased.
    */
    var selections = {};

    /* Pre-populate from first active buttons on page load */
    document.querySelectorAll('.cordset-size-btn.is-active, .cordset-swatch.is-active').forEach(function (btn) {
      if (btn.dataset.group && btn.dataset.value) {
        selections[btn.dataset.group] = btn.dataset.value;
      }
    });

    /* ── Swatch colors ───────────────────────────────────── */
    var COLOR_MAP = {
      'black':'#111111','white':'#FFFFFF','ivory':'#FFFFF0','cream':'#FFFDD0',
      'beige':'#F5F5DC','offwhite':'#FAF9F6','lilac':'#C8A8D8','lavender':'#B57BDB',
      'purple':'#800080','violet':'#7F00FF','pink':'#FFC0CB','blush':'#F9C8D0',
      'dustypink':'#DCAE96','rose':'#FF007F','hotpink':'#FF69B4','magenta':'#FF00FF',
      'red':'#FF0000','burgundy':'#800020','maroon':'#800000','rust':'#B7410E',
      'coral':'#FF7F7F','orange':'#FF7F00','peach':'#FFCBA4','yellow':'#FFE066',
      'mustard':'#FFDB58','gold':'#FFD700','green':'#008000','sage':'#BCB88A',
      'olive':'#808000','mint':'#98FF98','forestgreen':'#228B22','teal':'#008080',
      'turquoise':'#40E0D0','sky':'#A8C4D8','skyblue':'#87CEEB','blue':'#0000FF',
      'navy':'#000080','royalblue':'#4169E1','denim':'#1560BD','powderblue':'#B0E0E6',
      'brown':'#A52A2A','chocolate':'#7B3F00','tan':'#D2B48C','camel':'#C19A6B',
      'khaki':'#F0E68C','grey':'#808080','gray':'#808080','charcoal':'#36454F',
      'silver':'#C0C0C0','champagne':'#F7E7CE','nude':'#E3BC9A','rosegold':'#B76E79',
      'jade':'#00A86B','lightpink':'#FFB6C1','babypink':'#F4C2C2','lemon':'#FFF44F',
      'cobalt':'#0047AB','emerald':'#50C878','burgundy':'#800020','wine':'#722F37'
    };

    document.querySelectorAll('.cordset-swatch').forEach(function (swatch) {
      var colorName = (swatch.dataset.value || '').toLowerCase().replace(/\s+/g, '');
      swatch.style.backgroundColor = COLOR_MAP[colorName] || '#CCCCCC';
    });

    /* ── Gallery ─────────────────────────────────────────── */
    /*
      DESKTOP: 2-column image grid — hover shows zoom "+" icon,
               click any image to open lightbox zoom modal.
      MOBILE:  Single-image touch slider + horizontal thumbnail
               strip + dot pagination.
      Lightbox bottom controls: ← close × next →
    */

    var gridCells   = document.querySelectorAll('.cordset-gallery__cell');
    var totalSlides = gridCells.length;

    /* ── Desktop: click any grid image → open lightbox ──────── */
    gridCells.forEach(function (cell) {
      cell.addEventListener('click', function () {
        openLightbox(parseInt(this.dataset.index) || 0);
      });
      cell.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(parseInt(this.dataset.index) || 0);
        }
      });
    });

    /* ── Lightbox ────────────────────────────────────────────── */
    var lightbox   = document.getElementById('cordset-lightbox');
    var lbBackdrop = document.getElementById('cordset-lightbox-backdrop');
    var lbImgs     = document.querySelectorAll('.cordset-lightbox__img');
    var lbPrev     = document.getElementById('cordset-lb-prev');
    var lbNext     = document.getElementById('cordset-lb-next');
    var lbClose    = document.getElementById('cordset-lb-close');
    var lbCurrent  = 0;

    function openLightbox(index) {
      if (!lightbox || !totalSlides) return;
      lbCurrent = ((index % totalSlides) + totalSlides) % totalSlides;
      lbImgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === lbCurrent);
      });
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('prevent-scroll');
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('prevent-scroll');
    }

    function shiftLightbox(dir) {
      if (!totalSlides) return;
      lbImgs[lbCurrent] && lbImgs[lbCurrent].classList.remove('is-active');
      lbCurrent = ((lbCurrent + dir + totalSlides) % totalSlides);
      lbImgs[lbCurrent] && lbImgs[lbCurrent].classList.add('is-active');
    }

    if (lbClose)    lbClose.addEventListener('click', closeLightbox);
    if (lbBackdrop) lbBackdrop.addEventListener('click', closeLightbox);
    if (lbPrev)     lbPrev.addEventListener('click', function () { shiftLightbox(-1); });
    if (lbNext)     lbNext.addEventListener('click', function () { shiftLightbox(1); });

    document.addEventListener('keydown', function (e) {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowLeft')  shiftLightbox(-1);
      if (e.key === 'ArrowRight') shiftLightbox(1);
    });

    /* ── Mobile slider ───────────────────────────────────────── */
    var mobileTrack  = document.getElementById('cordset-mobile-track');
    var mobileThumbs = document.querySelectorAll('.cordset-gallery__mobile-thumb');
    var mobileDots   = document.querySelectorAll('.cordset-gallery__mobile-dot');
    var mSlide       = 0;

    function setMobileSlide(index) {
      if (!mobileTrack || !totalSlides) return;
      mSlide = ((index % totalSlides) + totalSlides) % totalSlides;

      mobileTrack.style.transform = 'translateX(-' + (mSlide * 100) + '%)';

      mobileThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === mSlide); });
      if (mobileThumbs[mSlide]) {
        mobileThumbs[mSlide].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      mobileDots.forEach(function (d, i) { d.classList.toggle('is-active', i === mSlide); });
    }

    mobileThumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { setMobileSlide(parseInt(this.dataset.index) || 0); });
    });
    mobileDots.forEach(function (dot) {
      dot.addEventListener('click', function () { setMobileSlide(parseInt(this.dataset.index) || 0); });
    });

    /* Touch swipe on the mobile gallery */
    var mobileGallery = document.getElementById('cordset-mobile-gallery');
    if (mobileGallery) {
      var tsX = 0, tsY = 0;
      mobileGallery.addEventListener('touchstart', function (e) {
        tsX = e.touches[0].clientX;
        tsY = e.touches[0].clientY;
      }, { passive: true });
      mobileGallery.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tsX;
        var dy = e.changedTouches[0].clientY - tsY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          setMobileSlide(mSlide + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }


    /* ── Variant selection ───────────────────────────────── */
    function handleVariantClick(btn) {
      var group   = btn.dataset.group;
      var value   = btn.dataset.value;
      var labelId = btn.dataset.labelId;
      if (!group || !value) return;

      selections[group] = value;

      document.querySelectorAll('[data-group="' + group + '"]').forEach(function (el) {
        el.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      if (labelId) {
        var label = document.getElementById(labelId);
        if (label) label.textContent = value;
      }

      updateSubtotal();
    }

    var infoPanel = document.querySelector('.cordset-info');
    if (infoPanel) {
      infoPanel.addEventListener('click', function (e) {
        var btn = e.target.closest('.cordset-size-btn, .cordset-swatch');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          handleVariantClick(btn);
        }
      });
    }


    /* ── Quantity ────────────────────────────────────────── */
    var qty        = 1;
    var qtyDisplay = document.getElementById('cordset-qty-val');

    function updateSubtotal() {
  var topV    = getTopVariant();
  var botV    = getBottomVariant();
  var topPrice    = topV    ? topV.price    : CORDSET_CONFIG.basePrice;
  var bottomPrice = botV    ? botV.price    : CORDSET_CONFIG.bottomBasePrice || 0;
  var combined    = (topPrice + bottomPrice) * qty;
  var subtotalEl  = document.getElementById('cordset-subtotal-val');
  if (subtotalEl) subtotalEl.textContent = formatMoney(combined);
}

    var minusBtn = document.getElementById('cordset-qty-minus');
    var plusBtn  = document.getElementById('cordset-qty-plus');

    if (minusBtn) minusBtn.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      updateSubtotal();
    });

    if (plusBtn) plusBtn.addEventListener('click', function () {
      qty++;
      if (qtyDisplay) qtyDisplay.textContent = qty;
      updateSubtotal();
    });


    /* ── Variant matching ────────────────────────────────── */
    /*
      For each variant, check that every selected option for
      this prefix matches the variant's option at that position.

      Example — bottom product has options: ["Color", "Product Chest Size (in Inches)"]
      bottomGroupMap = { "bottom-color": 0, "bottom-product chest size (in inches)": 1 }

      For a variant { option1: "Black", option2: "XS-34" }:
        selections["bottom-color"] === "Black"   → matches option1 ✓
        selections["bottom-product chest size..."] === "XS-34" → matches option2 ✓
    */
    function findVariant(variants, groupMap, currentSelections) {
      if (!variants || !variants.length) return null;

      /* Get only the keys relevant to this product's group map */
      var relevantKeys = Object.keys(groupMap);

      return variants.find(function (variant) {
        return relevantKeys.every(function (groupKey) {
          var optionIndex  = groupMap[groupKey];            /* 0, 1, or 2 */
          var optionField  = 'option' + (optionIndex + 1); /* "option1", "option2", "option3" */
          var selectedVal  = currentSelections[groupKey];

          /* If user hasn't selected this option yet, skip the check */
          if (selectedVal === undefined || selectedVal === null) return true;

          return variant[optionField] === selectedVal;
        });
      }) || null;
    }

    function getTopVariant() {
      return findVariant(topVariants, topGroupMap, selections);
    }

    function getBottomVariant() {
      return findVariant(bottomVariants, bottomGroupMap, selections);
    }


    /* ── Messages ───────────────────────────────────────── */
    function showMsg(type, text) {
      var errEl = document.getElementById('cordset-error');
      var sucEl = document.getElementById('cordset-success');
      if (!errEl || !sucEl) return;
      if (type === 'error') {
        errEl.textContent = text;
        errEl.style.display = 'block';
        sucEl.style.display = 'none';
        setTimeout(function () { errEl.style.display = 'none'; }, 5000);
      } else {
        sucEl.textContent = text;
        sucEl.style.display = 'block';
        errEl.style.display = 'none';
        setTimeout(function () { sucEl.style.display = 'none'; }, 4000);
      }
    }


    /* ── Validate ────────────────────────────────────────── */
    function validate() {
      var tc = document.getElementById('cordset-tc-checkbox');
      if (tc && !tc.checked) {
        showMsg('error', 'Please agree to the Terms & Conditions to continue.');
        return false;
      }
      if (!CORDSET_CONFIG.bottomProductId) {
        showMsg('error', 'This cordset is not fully configured. Please contact us.');
        return false;
      }

      var topV = getTopVariant();
      var botV = getBottomVariant();

      /* Debug helper — remove after confirming working */
      console.log('[Cordset] selections:', JSON.stringify(selections));
      console.log('[Cordset] topGroupMap:', JSON.stringify(topGroupMap));
      console.log('[Cordset] bottomGroupMap:', JSON.stringify(bottomGroupMap));
      console.log('[Cordset] topVariant found:', topV ? topV.id : 'NONE');
      console.log('[Cordset] bottomVariant found:', botV ? botV.id : 'NONE');

      if (!topV) {
        showMsg('error', 'Please select all options for the Top.');
        return false;
      }
      if (!botV) {
        showMsg('error', 'Please select all options for the Bottom.');
        return false;
      }
      if (!topV.available) {
        showMsg('error', 'The selected Top is currently out of stock.');
        return false;
      }
      if (!botV.available) {
        showMsg('error', 'The selected Bottom is currently out of stock.');
        return false;
      }
      return { topVariantId: topV.id, bottomVariantId: botV.id };
    }


    /* ── Cart ────────────────────────────────────────────── */
    function setLoading(btnId, loading, label) {
      var btn = document.getElementById(btnId);
      if (!btn) return;
      if (loading) {
        btn.classList.add('is-loading');
        btn.innerHTML = '<span class="cordset-spinner"></span> Adding...';
      } else {
        btn.classList.remove('is-loading');
        btn.textContent = label;
      }
    }

    function addToCart(topVariantId, bottomVariantId, btnId, btnLabel, redirect) {
  var pairKey = Date.now().toString();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: topVariantId,
          quantity: qty,
          properties: {
            '_cordset_pair': 'top',
            '_paired_key': pairKey
          }
        },
        {
          id: bottomVariantId,
          quantity: qty,
          properties: {
            '_cordset_pair': 'bottom',
            '_paired_key': pairKey,
            'Part of the Co-ord Set': 'Cannot be removed \u2022'
          }
        }
      ]
    })
  })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error adding to cart'); });
        return r.json();
      })
      .then(function () {
        setLoading(btnId, false, btnLabel);
        if (redirect) {
          window.location.href = '/checkout';
        } else {
          showMsg('success', 'Both pieces added to cart!');
          refreshCartCount();
          openCartDrawer();
        }
      })
      .catch(function (err) {
        setLoading(btnId, false, btnLabel);
        showMsg('error', err.message || 'Something went wrong. Please try again.');
      });
    }


    var atcBtn = document.getElementById('cordset-atc-btn');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var result = validate();
        if (!result) return;
        setLoading('cordset-atc-btn', true);
        addToCart(result.topVariantId, result.bottomVariantId, 'cordset-atc-btn', 'Add to Cart', false);
      });
    }

    var binBtn = document.getElementById('cordset-bin-btn');
    if (binBtn) {
      binBtn.addEventListener('click', function () {
        var result = validate();
        if (!result) return;
        setLoading('cordset-bin-btn', true);
        addToCart(result.topVariantId, result.bottomVariantId, 'cordset-bin-btn', 'Buy it Now', true);
      });
    }


    /* ── Cart count + drawer update (Minimog) ───────────── */
    function refreshCartCount() {
      /* Minimog cart count bubble selector from cart-drawer.js */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
            if (count > 0) {
              el.textContent = count;
              el.classList.remove('m:hidden');
            } else {
              el.classList.add('m:hidden');
            }
          });
        })
        .catch(function () {});
    }

    /* ── Open cart drawer (Minimog) ─────────────────────── */
    function openCartDrawer() {
      /* Minimog uses <m-cart-drawer> custom element — from cart-drawer.js:
         - .onCartDrawerUpdate() fetches ?section_id=cart-drawer and re-renders
         - .open() adds class m-cart-drawer--active and slides in the drawer   */
      var cartDrawer = document.querySelector('m-cart-drawer');
      if (!cartDrawer) return;

      /* Re-render drawer contents with latest cart, then open */
      fetch(window.Shopify.routes.root + 'cart?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var sections = [
            '[data-minimog-cart-items]',
            '[data-minimog-cart-discounts]',
            '[data-cart-subtotal]',
            '[data-minimog-gift-wrapping]'
          ];

          sections.forEach(function (selector) {
            var target = cartDrawer.querySelector(selector);
            var source = doc.querySelector(selector);
            if (target && source) target.innerHTML = source.innerHTML;
          });

          /* Update empty state */
          cartDrawer.classList.remove('m-cart--empty');

          /* Open the drawer — mirrors MCartDrawer.open() in cart-drawer.js */
          cartDrawer.classList.add('m-cart-drawer--active');
          requestAnimationFrame(function () {
            cartDrawer.style.setProperty('--m-bg-opacity', '0.5');
            var inner = cartDrawer.querySelector('.m-cart-drawer__inner');
            if (inner) inner.style.setProperty('--translate-x', '0');
          });
          document.documentElement.classList.add('prevent-scroll');

          /* Fire Minimog pubsub so other components stay in sync */
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
          }
        })
        .catch(function () {});
    }


    /* ── Money formatter ─────────────────────────────────── */
    function formatMoney(cents) {
      /* Auto-detect currency from CORDSET_CONFIG or page */
      var symbol = '\u20B9'; /* ₹ default — change to '$' or '£' etc for other stores */
      var amount = Math.round(cents / 100);
      return symbol + '\u00A0' + amount.toLocaleString('en-IN');
    }

  } /* end init() */

})();